module.exports = __webpack_public_path__ + "img/securitydetailsList1.0c9d7788.png";